// extracted by mini-css-extract-plugin
export default {"toggle-switch":"xqpGmlD","toggle-switch__label":"v_dXQL_","toggle-switch__switch-wrapper":"jYFiH05","toggle-switch__switch-visual":"jaXyEbc","toggle-switch__input":"F6t6_HZ"};